module.exports = __webpack_public_path__ + "img/logo.50fe6994.png";